// src/router/relatoriosV2.js

// Quem abre os relatórios de solicitações (TRI-107; o admin passa). Aplicado pelo guard de
// @/router/permissoes.js, que o menu lateral também usa. As rotas genéricas de Power BI
// (/relatorios/:reportUrl e o cadastro) estão fora do menu e seguem sem guarda até a decisão do time.
const ROLES_SOLICITACOES = ['report_access_all', 'triveni_compras', 'triveni_governanca', 'diretoria', 'financeiro']


const relatoriosBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    }
]

export default [
    {
        path: '/relatorios/:reportUrl',
        name: 'RelatorioAccess',
        component: () => import('@/views/Relatorios/PowerBi/ReportAccess.vue'),
        meta: {
            title: 'Relatório',
            breadcrumb: [
                ...relatoriosBreadCrumb
            ]
        }
    },
    {
        path: '/relatorios',
        name: 'Relatorios',
        component: () => import('@/views/Relatorios/PowerBi/RelatorioListPage.vue'),
        meta: {
            title: 'Relatórios',
            breadcrumb: relatoriosBreadCrumb
        },
    },
    {
        path: '/relatorios/:id/detalhes',
        name: 'RelatorioDetalhes',
        component: () => import('@/views/Relatorios/PowerBi/NovoRelatorioPage.vue'),
        meta: {
            title: 'Detalhes do Relatório',
            breadcrumb: [
                ...relatoriosBreadCrumb,
                {
                    label: 'Detalhes',
                    to: 'RelatorioNovo'
                }
            ]
        }
    },
    {
        path: '/relatorios/novo',
        name: 'RelatorioNovo',
        component: () => import('@/views/Relatorios/PowerBi/NovoRelatorioPage.vue'),
        meta: {
            title: 'Novo Relatório',
            breadcrumb: [
                ...relatoriosBreadCrumb,
                {
                    label: 'Novo Relatório',
                    to: 'RelatorioNovo'
                }
            ]
        }
    },
    {
        path: '/relatorios/:reportUrl/full-screen',
        name: 'RelatorioAccessFullScreen',
        component: () => import('@/views/Relatorios/PowerBi/ReportAccess.vue'),
        meta: {
            title: 'Relatório',
            breadcrumb: [
                ...relatoriosBreadCrumb
            ]
        }
    },
    {
        path: '/relatorios/solicitacao-compra',
        name: 'RelatorioSolicitacaoCompra',
        component: () => import('@/views/Relatorios/SolicitacaoCompra/ListPage.vue'),
        meta: {
            roles: ROLES_SOLICITACOES,
            title: 'Solicitações de Compras',
            breadcrumb: [
                ...relatoriosBreadCrumb,
                {
                    label: 'Solicitações de Compras',
                    to: 'RelatorioSolicitacaoCompra'
                }
            ]
        }
    },
    {
        path: '/relatorios/solicitacao-viagem',
        name: 'RelatorioSolicitacaoViagem',
        component: () => import('@/views/Relatorios/SolicitacaoViagem/ListPage.vue'),
        meta: {
            roles: ROLES_SOLICITACOES,
            title: 'Solicitações de Viagens',
            breadcrumb: [
                ...relatoriosBreadCrumb,
                {
                    label: 'Solicitações de Viagens',
                    to: 'RelatorioSolicitacaoViagem'
                }
            ]
        }
    }

];
